import React, { forwardRef } from 'react';
import useUniqueId from 'hooks/useUniqueId';
import { hasReactChildren } from 'utils/ui';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import Box from 'components/Box';
import { RadioButton } from 'components/RadioButtonOption';
import Stack from 'components/Stack';
import SelectionIndicator from 'components/ItemPicker/ListItem/SelectionIndicator';
import Text from 'components/Text';
import ActionMenu from './ActionMenu';
var SelectableBadgeImage = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var badgeImage = _ref.badgeImage,
    label = _ref.label,
    parentPlaylistId = _ref.parentPlaylistId,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    isEditable = _ref.isEditable,
    onSelect = _ref.onSelect,
    onDelete = _ref.onDelete,
    children = _ref.children;
  var uniqueId = useUniqueId();
  var inputId = "".concat(uniqueId, "-radio");
  var labelId = "".concat(uniqueId, "-label");
  var hasImage = hasReactChildren(children);
  // Only playlist admins can edit badge images
  var isPlaylistAdmin = hasPrivilege(PLAYLIST_WRITE);
  var hasActionMenu = isEditable && isPlaylistAdmin && badgeImage;
  return /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    textAlign: "center",
    display: "flex",
    stackItems: true,
    justifyContent: "center",
    height: "100%",
    minHeight: 140,
    p: "xs",
    py: "s",
    z: 0,
    background: isSelected ? null : 'shaded',
    borderRadius: "small"
  }, isSelected && /*#__PURE__*/React.createElement(SelectionIndicator, {
    borderRightRadius: "small"
  }), /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: "xs",
    left: "xs",
    z: "raised"
  }, /*#__PURE__*/React.createElement(RadioButton, {
    id: inputId,
    checked: isSelected,
    ref: ref,
    onChange: function onChange() {
      return onSelect(badgeImage === null || badgeImage === void 0 ? void 0 : badgeImage.imageId);
    }
  })), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, children, /*#__PURE__*/React.createElement(Text, {
    as: "label",
    htmlFor: inputId,
    id: labelId,
    fontSize: hasImage ? 'xxs' : 'xs',
    bold: !hasImage,
    overflow: "wrap"
  }, label, /*#__PURE__*/React.createElement(Box, {
    fillParent: true,
    style: {
      cursor: 'pointer'
    }
  }))), hasActionMenu && /*#__PURE__*/React.createElement(ActionMenu, {
    badgeImage: badgeImage,
    onDelete: onDelete,
    parentPlaylistId: parentPlaylistId,
    titleId: labelId
  }));
});
SelectableBadgeImage.displayName = 'SelectableBadgeImage';
export default SelectableBadgeImage;